import getTheLang from '@/global/i18n/get-the-lang';

const inner = require.context('@/lang/inner/zh-CN', false, /\.js$/);
export default getTheLang({ pack: inner, extraArray: [] });
